/**
 * Parse JSON API responses with consistent error handling.
 */
export async function parseApiResponse(res) {
  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error(`Request failed (${res.status})`);
  }

  if (!res.ok || !data.success) {
    const error = new Error(data.message || `Request failed (${res.status})`);
    error.status = res.status;
    if (data.code) error.code = data.code;
    throw error;
  }

  return data;
}
